import React from 'react';
import classNames from 'classnames';
import UserAvatar, { AvatarSize } from 'Douleutaras/components/UserAvatar/UserAvatar';

import './AvatarStack.scss';

// Maximum number of avatars rendered in the stack before the count bubble.
// Keeps the stack visually balanced regardless of how many pros there are.
const MAX_AVATARS = 4;

export interface AvatarStackPro {
  id: string;
  mugshot: string;
  name: string;
  isTopPro: boolean;
}

// Stack scale: `default` is the 38px extra-bid stack; `small` is the 32px variant.
export type AvatarStackSize = 'default' | 'small';

const AVATAR_SIZE_BY_STACK_SIZE: Record<AvatarStackSize, AvatarSize> = {
  default: AvatarSize.EXTRA_BID,
  small: AvatarSize.EXTRA_BID_SMALL
};

export interface AvatarStackProps {
  pros: Array<AvatarStackPro>;
  // Separate from `pros.length` - typically a broader "N other available" count
  // (e.g. from the pros_list endpoint), not literally how many avatars are shown.
  totalCount: number;
  size?: AvatarStackSize;
  onClick?(): void;
}

const AvatarStack = ({ pros, totalCount, size = 'default', onClick }: AvatarStackProps) => (
  <div styleName={classNames('avatar-stack', { 'avatar-stack--small': size === 'small' })} onClick={onClick} role="button">
    { pros.slice(0, MAX_AVATARS)
      .map(pro => (
        <span styleName={classNames('avatar-stack__item', { 'avatar-stack__item--top-pro': pro.isTopPro })} key={`avatar-stack-item-${pro.id}`}>
          <UserAvatar
            size={AVATAR_SIZE_BY_STACK_SIZE[size]}
            mugshot={pro.mugshot}
            username={pro.name}
          />
        </span>
      ))}
    { totalCount > 0 &&
      <span styleName="avatar-stack__count">{`+${totalCount}`}</span>
    }
  </div>
);

export default AvatarStack;
